/** Lists the IDs of all static cells that are available for */
export enum EIssueLikeQueryableEntityTypeField {
	ID = 'id',
	SUBJECT = 'subject',
	STATUS = 'status',
	ASSIGNEE = 'assignee',
	AUTHOR = 'author',
	PARENT_ID = 'parentId',
	CLOSED = 'closed',
	CREATED = 'created',
	UPDATED = 'updated',
	TYPE = 'type',
	CONNECTOR = 'connector'
}
